import React from "react";
//
import {
  Container,
  Accordion,
  ThemeIcon,
  useMantineTheme,
} from "@mantine/core";
import { IconHelpCircle } from "@tabler/icons-react";

//
import type { UiSection } from "@neuromotion-inc/mightier-survey-engine";
import type { SurveyEngineIface } from "src/services/surveyHooks/useSurveyEngine";
import { SurveyRichText } from "../survey-rich-text/survey-rich-text";
//
// tyles
import css from "./survey-ui-section.module.css";

interface SurveyUiSectionProps {
  section: UiSection;
  surveyEngine: SurveyEngineIface;
}

const InfoIcon: React.FC = () => (
  <ThemeIcon variant="transparent">
    <IconHelpCircle />
  </ThemeIcon>
);

export const SurveyUiSection = React.memo<SurveyUiSectionProps>(
  function SurveyUiSection(props) {
    const { section, surveyEngine } = props;
    const theme = useMantineTheme();

    return (
      <Container>
        {section.title ? (
          <SurveyRichText
            text={section.title.translation_key}
            className={css["title-text"]}
            surveyEngine={surveyEngine}
          />
        ) : null}

        {/* expandable notes */}
        {section.expandable_notes?.length ? (
          <Accordion>
            {section.expandable_notes.map((note, idx) => {
              return (
                <Accordion.Item key={idx} value={idx.toString()}>
                  <Accordion.Control icon={<InfoIcon />}>
                    <SurveyRichText
                      text={note.title_translation_key}
                      className={css["description-text"]}
                      surveyEngine={surveyEngine}
                      fw={700}
                      c={theme.primaryColor}
                    />
                  </Accordion.Control>
                  <Accordion.Panel>
                    <SurveyRichText
                      text={note.copy_translation_key}
                      className={css["description-text"]}
                      surveyEngine={surveyEngine}
                    />
                  </Accordion.Panel>
                </Accordion.Item>
              );
            })}
          </Accordion>
        ) : null}

        {section.description ? (
          <SurveyRichText
            text={section.description}
            className={css["description-text"]}
            surveyEngine={surveyEngine}
          />
        ) : null}
      </Container>
    );
  },
);
